<template>
	<div
		tabindex="0"
		class="radio-bar"
		@click="trackRadioClick(`select${groupType.radioName}`, groupType)"
		role="button"
		:class="{ isChecked: groupType.selected }"
	>
		<span class="icon-label-holder">
			<span class="icon">
				<font-awesome-icon :icon="[iconWeight, icon]" />
			</span>
			<span class="radio-bar-title">{{ groupType.typeName }}</span>
		</span>
		<Radio
			:radioId="`${groupType.groupName}-${groupType.index}`"
			:radioGroupName="`${groupType.groupName}-${radioKey}`"
			:isChecked="groupType.selected"
			:radioDescription="`${groupType.groupName} media group radio`"
		/>
	</div>
</template>

<script>
import { mapActions } from 'vuex';
import Radio from '@/components/global/Radio.vue';

export default {
	name: 'BbMediaPicker',
	components: { Radio },
	props: {
		groupType: Object,
		value: String,
		radioKey: Number,
		icon: String,
		iconWeight: String,
	},
	methods: {
		...mapActions([
			'selectMediaType',
			'selectAudienceType',
			'resetDefaultSelections',
		]),

		trackRadioClick(radioName, dataObject) {
			if (radioName === 'selectMediaType') {
				this.selectMediaType(dataObject);
				this.resetDefaultSelections({ clearMediaType: false });
			} else if (radioName === 'selectAudienceType') {
				this.selectAudienceType(dataObject);
			} else {
				// TODO: Fix mostly silent error handling
				// eslint-disable-next-line no-console
				console.error('trackRadioClick Error');
			}
		},
	},
};
</script>

<style lang="scss" scoped>
.radio-bar {
	@include rem(padding, 9px 15px);
	@include rem(margin-bottom, 10px);
	display: flex;
	justify-content: space-between;
	align-items: center;
	border-radius: $b360-border-radius-base;
	box-shadow: inset 0 0 0 $b360-border-width-thin $border-color-light;
	background-color: $off-white;

	&:hover,
	&:focus,
	&.isChecked {
		box-shadow: inset 0 0 0 $b360-border-width-medium $brand-teal;

		.custom-radio {
			background-color: $brand-teal;
			box-shadow: inset 0 0 0 $b360-border-width-thin $brand-teal;
		}
	}

	&:hover {
		cursor: pointer;
	}
}

.icon-label-holder {
	display: flex;
	align-items: center;

	.icon {
		color: $brand-teal;
		@include rem(font-size, 26px);
	}
}

.radio-bar-title {
	@include rem(margin-left, 15px);
	@include typo--roboto__medium;
	font-size: $b360-font-size--base;
	color: $text-base-color;
}

.radio-bar-colors {
	width: 100px;
	line-height: 0;
}

.hidden-radio {
	position: absolute;
	left: 0;
	top: 0;
	margin: 0;
	padding: 0;
	opacity: 0;

	&:checked {
		& + .custom-radio-button svg {
			fill: $white;
		}
	}
}

.custom-radio {
	@include rem(width, 18px);
	@include rem(height, 18px);
	position: relative;
	display: inline-block;

	border-radius: $b360-border-radius-base;
	background-color: transparent;
	transition: $b360-motion-selection;
}

.is-checked {
	.custom-radio-button {
		border: $b360-border-width-medium solid $brand-teal;
	}
}

.custom-radio-button {
	width: 16px;
	height: 16px;
	display: flex;
	justify-content: center;
	align-items: center;
	margin: 0;
	background-color: $white;
	border: $b360-border-width-thin solid $border-color-light;

	svg {
		@include rem(width, 12px);
		@include rem(height, 12px);
		fill: transparent;
		transition: fill $b360-motion-duration--shorter
			$b360-motion-easing--accelerate;
	}
}
</style>
